module.exports = __webpack_public_path__ + "img/temple_banner.9a5fd6e5.png";